'use client'

import { useTranslations } from 'next-intl'
import styles from './VisaRenewal.module.css'
import TimelineGuide from '@/components/ui/TimelineGuide/TimelineGuide'

export default function VisaRenewalSteps() {
  const t = useTranslations('VisaGuidePage.renewalTabs.visaRenewal')

  const strong = {
    strong: (chunks: React.ReactNode) => <strong className={styles.emphasis}>{chunks}</strong>,
  }

  const richText = {
    strong: (chunks: React.ReactNode) => <strong className={styles.emphasis}>{chunks}</strong>,
    link: (chunks: React.ReactNode) => (
      <a href="https://my.utm.my/login" target="_blank" rel="noopener noreferrer" className={styles.stepLink}>
        {chunks}
      </a>
    ),
    email: (chunks: React.ReactNode) => (
      <a href="mailto:iscjb@utm.my" className={styles.stepLink}>
        {chunks}
      </a>
    ),
  }

  const STEPS = [
    {
      id: 1,
      title: t('steps.1.title'),
      description: t.rich('steps.1.description', richText),
      image: '/images/visa-guide/step1.png',
      layout: 'right' as const,
      showBadge: true,
    },
    {
      id: 2,
      title: t('steps.2.title'),
      description: t.rich('steps.2.description', strong),
      image: '/images/visa-guide/step2.webp',
      layout: 'left' as const,
      showBadge: true,
    },
    {
      id: 3,
      title: t('steps.3.title'),
      description: t.rich('steps.3.description', strong),
      image: '/images/visa-guide/step3.webp',
      layout: 'right' as const,
      showBadge: true,
    },
    {
      id: 4,
      title: t('steps.4.title'),
      description: t.rich('steps.4.description', strong),
      image: '/images/visa-guide/step4.webp',
      layout: 'left' as const,
      showBadge: true, // was false — caused the badge to skip from 3 to 5
    },
    {
      id: 5,
      title: t('steps.5.title'),
      description: t.rich('steps.5.description', strong),
      image: '/images/visa-guide/step5.1.webp',
      layout: 'right' as const,
      showBadge: true,
    },
    {
      id: '5.2',
      title: '',
      description: t.rich('steps.5.parts.2', strong),
      image: '/images/visa-guide/step5.2.webp',
      layout: 'left' as const,
      showBadge: false,
    },
    {
      id: '5.3',
      title: '',
      description: t.rich('steps.5.parts.3', strong),
      image: '/images/visa-guide/step5.3.webp',
      layout: 'right' as const,
      showBadge: false,
    },
    {
      id: 6,
      title: t('steps.6.title'),
      description: t.rich('steps.6.description', richText),
      image: '/images/visa-guide/step6.webp',
      layout: 'left' as const,
      showBadge: false,
    },
  ]

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <TimelineGuide steps={STEPS} />
      </div>
    </section>
  )
}